import type { ComponentEditorMetaDataDefinition } from '../types';

const metaData: ComponentEditorMetaDataDefinition = {
  selectable: false,
  slideContainer: true,
};

export default metaData;
